export const VIDEO_TEMPLATE_COLORS = ['#4E3F27', '#1E88E5', '#7B1FA2', '#C62828', '#EF6C00', '#2E7D32', '#EFB8C8'];
